export const TRANSPARENT_PLACEHOLDER = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';


export const BASE_URL = 'https://api.honeycoolgreen.com/'
// export const BASE_URL = 'http://192.168.31.178:9090/'
// export const BASE_URL = 'http://10.154.55.45:9090/'
export const RAZORPAY_KEY = 'rzp_test_HkzyriLfjgebbp';
